import React, { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLayoutContext } from '../../../components/layout/Layout';
import { getMakecodeArcadePageRootStyle } from '../makecodeArcadePageStyles';
import Button from '../../../components/ui/Button';
import LeftArrowIcon from '../../../components/icons/LeftArrowIcon';
import { explainPaperStyle, explainExampleTitleStyle, explainPaperTitleStyle, explainPaperTextStyle, explainExamplePaperStyle, explainExampleTextStyle, explainExampleImageBoxStyle} from '../../../styles/commonStyles';

const TextSpriteExplain: React.FC = () => {
  const navigate = useNavigate();
  const { isMobile } = useLayoutContext();
  const exampleRef = useRef<HTMLDivElement>(null);
  const practiceRef = useRef<HTMLDivElement>(null);

  return (
    <div style={getMakecodeArcadePageRootStyle(isMobile)}>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '24px' }}>
        <Button variant="line" leftIcon={<LeftArrowIcon width={20} height={20} />} onClick={() => navigate('/makecodearcade/explains/')} style={{ marginRight: '16px' }}>
          돌아가기
        </Button>
        <h1 style={{ margin: 0, fontSize: '24px', fontFamily: 'var(--font-family-primary)' }}>Text Sprite 알아보기</h1>
      </div>
      <div style={{ marginBottom: '24px', border: '1px solid #ccc', padding: '16px', borderRadius: '8px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
        <h2 style={{ fontWeight: 700, marginBottom: '16px', fontSize: '18px' }}>
          📚 목차
        </h2>
        <ul style={{ listStyleType: 'none', padding: 0 }}>
          <li style={{marginBottom: '8px'}}>
            <a href="#text-sprite-기능-추가하기" style ={{textDecoration: 'none', color: '#1976d2', fontWeight: 500}}>
              Text Sprite 기능 추가하기
            </a>
          </li>
          <li style={{marginBottom: '8px'}}>
            <a href="#text-sprite-블록-알아보기" style ={{textDecoration: 'none', color: '#1976d2', fontWeight: 500}}>
              Text Sprite 블록 알아보기
            </a>
          </li>
            <ul style={{ listStyleType: 'circle', paddingLeft: '20px', marginTop: '6px' }}>
              <li style={{ marginBottom: '3px' }}>
                <a href="#text-sprite-변수-선언하기" style={{ textDecoration: 'none', color: '#555' }}>
                  TextSprite를 위한 변수 선언
                </a>
              </li>
              <li style={{ marginBottom: '3px' }}>
                <a href="#text-sprite-변수-선언하면서-동시에-글자색-배경색-바꾸기" style={{ textDecoration: 'none', color: '#555' }}>
                  TextSprite 변수 선언하면서 동시에 글자색, 배경색 바꾸기
                </a>
              </li>
              <li style={{ marginBottom: '3px' }}>
                <a href="#text-sprite-글자-크기-조정하기" style={{ textDecoration: 'none', color: '#555' }}>
                  TextSprite 글자 크기 조정하기
                </a>
              </li>
              <li style={{ marginBottom: '3px' }}>
                <a href="#text-sprite-글자-테두리-추가하기" style={{ textDecoration: 'none', color: '#555' }}>
                  TextSprite 글자 테두리 추가하기
                </a>
              </li>
              <li style={{ marginBottom: '3px' }}>
                <a href="#text-sprite-박스-테두리-추가하기" style={{ textDecoration: 'none', color: '#555' }}>
                  TextSprite 박스 테두리 추가하기
                </a>
              </li>
              <li style={{ marginBottom: '3px' }}>
                <a href="#text-sprite-텍스트-변경하기" style={{ textDecoration: 'none', color: '#555' }}>
                  TextSprite 텍스트 변경하기
                </a>
              </li>
              <li style={{ marginBottom: '3px' }}>
                <a href="#text-sprite-아이콘-추가하기" style={{ textDecoration: 'none', color: '#555' }}>
                  TextSprite 아이콘 추가하기
                </a>
              </li>
            </ul>
        </ul>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '24px', gap: '16px' }}>
        <img src="/images/makecodearcade/explains/SpriteText/arcadetext00.jpeg" alt="포켓몬스터 금은 사진" style={{ width: '10%', height: 'auto', borderRadius: '8px' }} />
        <img src="/images/makecodearcade/explains/SpriteText/arcadetext1.png" alt="Text Sprite 확장 블록 사진" style={{ width: '20%', height: 'auto', borderRadius: '8px' }} />
        <p style={{ margin: 0, color: 'var(--Color-text-normal)' }}>
          Makecode Arcade에서 게임의 제목을 표시할 때 주로 "타이틀 표시" 블록을 사용해서 간단하게 표시합니다<br/>
          "타이틀 표시" 블록을 사용하여 제목을 표시하는 경우 간단하나 사용자에게 강한 인상을 남기지 못하곤 합니다.<br/>
          실제로 게임을 플레이 하다보면 화면에 텍스트가 표기되어 있는 것을 많이 볼 수 있으며, 게임 시작 시 시작화면에 많이 사용하곤 합니다.
          이러한 텍스트를 표시하기 위해서는 우리는 Text Sprite를 사용할 수 있습니다.<br/>
        </p>
      </div>
      <h2 style={{ fontWeight: 700, marginBottom: '8px', fontSize: '18px' }} id="text-sprite-기능-추가하기">Text Sprite 기능 추가하기</h2>
      <div style={{ display: 'flex', alignItems: 'flex-end', marginBottom: '24px', gap: '16px' }}>
      <img src="/images/makecodearcade/explains/SpriteText/arcade-text.png" alt="Text Sprite 확장 블록 사진" style={{ width: '20%', height: 'auto', borderRadius: '8px' }} />
      <p style={{ marginBottom: '16px', color: 'var(--Color-text-normal)' }}>
        arcade-text는 화면에 텍스트를 바로 표시할 수 있는 확장 블록입니다.<br/>
        보통은 텍스트를 표시하기 위해서는 대화상자를 활용합니다.<br/>
        다만 화면에 바로 배경처럼 표시하고 싶다면 우리는 Text Sprite를 사용할 수 있습니다.
        쉽게는 Makecode Arcade에서 텍스트를 스프라이트 형태로 표시한다고 생각하시면 됩니다.<br/>
        먼저 확장 기능을 추가해야 합니다.<br/>
        arcade-text는 Makecode Arcade에서 공식적으로 제공하는 확장 기능이기에 에디터 안에서 바로 추가할 수 있습니다.<br/>
        에디터의 도구상자에서 "확장" 도구상자를 클릭하고 "arcade-text"를 검색, 혹은 스크롤하여 찾으신 다음 선택하여 추가합니다.
      </p>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '24px', gap: '16px' }}>
        <img src="/images/makecodearcade/explains/SpriteText/arcadetext2.png" alt="Text Sprite 도구상자 사진" style={{ width: '20%', height: 'auto' }} />
        <p style={{ marginBottom: '8px', color: 'var(--Color-text-normal)' }}>
          제대로 추가된 경우 왼쪽과 같은 기능이 도구 상자에 추가되는 것을 확인하실 수 있습니다.
        </p>
      </div>
      <div style={{ display: 'flex', alignItems: 'flex-end', marginBottom: '24px', gap: '16px' }}>
        <img src="/images/makecodearcade/explains/SpriteText/arcadetext3.png" alt="Text Sprite 블록들" style={{ width: '30%', height: 'auto' }} />
        <p style={explainPaperTextStyle}>
          그리고 "Text Sprite" 도구 상자를 클릭해보면 왼쪽의 블록들이 보이게 됩니다.<br/>
          이제 이 블록들을 통해 텍스트를 표시할 수 있습니다.<br/>
          <br/>
          자세히 보게되면 "스프라이트" 도구 상자에서 스프라이트를 생성하기 위한 블록들과 유사한 모양을 하고 있습니다.<br/>
        </p>
      </div>
      <h2 style={{ fontWeight: 700, marginBottom: '8px', fontSize: '18px' }} id="text-sprite-블록-알아보기">Text Sprite 블록 알아보기</h2>
      <p style={{ marginBottom: '16px', color: 'var(--Color-text-normal)' }}>Text Sprite 도구 상자의 블록을 알아봅시다.</p>

      <div style={explainPaperStyle} id="text-sprite-변수-선언하기">
        <h3 style={explainPaperTitleStyle}>
          1. TextSprite를 위한 변수 선언
        </h3>
        <p style={explainPaperTextStyle}>
          Text Sprite를 위한 변수를 선언하는 블록입니다.
        </p>
        <img src="/images/makecodearcade/explains/SpriteText/arcadetext4.png" alt="Text Sprite 블록들" style={{ width: '100%', height: 'auto' }} />
        <p style={explainPaperTextStyle}>
          <b>textSprite</b>라는 변수를 선언한 후 그 안에 text sprite 형태의 ""를 저장합니다.<br/>
          기본적으로 스프라이트를 생성할 때와 같으며 변수 이름은 자유롭게 지정할 수 있습니다.
        </p>
        <p style={{ marginBottom: '8px', color: 'var(--Color-text-normal)' }}>
          사용 예시:
        </p>
        <div style={explainExamplePaperStyle}>
          <div style={explainExampleImageBoxStyle}>
            <img src="/images/makecodearcade/explains/SpriteText/arcadetext5.png" alt="Text Sprite 블록들" style={{ width: '70%', height: 'auto' }} />
            <div style={{ width: 1, alignSelf: 'stretch', backgroundColor: 'var(--Color-line-normal)', margin: '0 8px' }} />
            <img src="/images/makecodearcade/explains/SpriteText/arcadetext6.png" alt="Text Sprite 블록들" style={{ width: '25%', height: 'auto' }} />
          </div>
        </div>
      </div>

      <div style={explainPaperStyle} id="text-sprite-변수-선언하면서-동시에-글자색-배경색-바꾸기">
        <h3 style={explainPaperTitleStyle}>
          2. TextSprite 변수 선언하면서 동시에 글자색, 배경색 바꾸기
        </h3>
        <div style={{ display: 'flex', alignItems: 'flex-end', gap: '16px', marginBottom: '16px' }}>
          <img src="/images/makecodearcade/explains/SpriteText/arcadetext8.png" alt="Text Sprite 추가 옵션 클릭하기" style={{ width: '50%', height: 'auto' }} />
          <p style={{ ...explainPaperTextStyle, fontSize: '14px' }}>
          Text Sprite를 추가하면서 동시에 글자색, 배경색을 변경할 수 있습니다.<br/>
          textSprite 변수를 선언하고 블록 안의 + 버튼을 클릭하면 아래와 같은 옵션 창이 나옵니다.
        </p>
        </div>
        <img src="/images/makecodearcade/explains/SpriteText/arcadetext7.png" alt="Text Sprite 블록들" style={{ width: '100%', height: 'auto' }} />
        <p style={explainPaperTextStyle}>
          <b>as</b>는 글자색을 변경할 수 있으며, <b>on</b>은 글자의 배경색을 변경할 수 있습니다.
        </p>
        <p style={{ marginBottom: '8px', color: 'var(--Color-text-normal)' }}>
          사용 예시:
        </p>
        <div style={explainExamplePaperStyle}>
          <div style={explainExampleImageBoxStyle}>
            <img src="/images/makecodearcade/explains/SpriteText/arcadetext9.png" alt="Text Sprite 블록들" style={{ width: '70%', height: 'auto' }} />
            <div style={{ width: 1, alignSelf: 'stretch', backgroundColor: 'var(--Color-line-normal)', margin: '0 8px' }} />
            <img src="/images/makecodearcade/explains/SpriteText/arcadetext10.png" alt="Text Sprite 블록들" style={{ width: '25%', height: 'auto' }} />
          </div>
        </div>
      </div>

      <div style={explainPaperStyle} id="text-sprite-글자-크기-조정하기">
        <h3 style={explainPaperTitleStyle}>
          3. TextSprite 글자 크기 조정하기
        </h3>
        <div style={{ display: 'flex', alignItems: 'flex-end', gap: '16px', marginBottom: '16px' }}>
          <img src="/images/makecodearcade/explains/SpriteText/arcadetext11.png" alt="Text Sprite 글자 크기 조정하기" style={{ width: '30%', height: 'auto' }} />
          <p style={{ ...explainPaperTextStyle, fontSize: '14px' }}>
          textSprite 변수 안의 text 스프라이트의 크기(height)를 조정할 수 있습니다.<br/>
          기본 높이는 0으로 시작하며 원하는 높이로 조정할 수 있습니다.<br/>
          <b style={{ color: 'red' }}>다만, 아직 한국어 텍스트에 대해서는 적용되지 않습니다.ㅠㅠ....</b>
        </p>
        </div>
        <p style={{ marginBottom: '8px', fontSize: '14px', color: 'var(--Color-text-normal)' }}>
          사용 예시:
        </p>
        <div style={explainExamplePaperStyle}>
          <div style={explainExampleImageBoxStyle}>
            <img src="/images/makecodearcade/explains/SpriteText/arcadetext13.png" alt="Text Sprite 글자 크기 조정 적용" style={{ width: '70%', height: 'auto' }} />
            <div style={{ width: 1, alignSelf: 'stretch', backgroundColor: 'var(--Color-line-normal)', margin: '0 8px' }} />
            <img src="/images/makecodearcade/explains/SpriteText/arcadetext14.png" alt="Text Sprite 글자 크기 조정 시뮬레이터" style={{ width: '25%', height: 'auto' }} />
          </div>
        </div>

      </div>

      <div style={explainPaperStyle} id="text-sprite-글자-테두리-추가하기">
          <h3 style={explainPaperTitleStyle}>
            4. TextSprite 글자 테두리 추가하기
          </h3>
          <div style={{ display: 'flex', alignItems: 'flex-end', gap: '16px', marginBottom: '16px' }}>
            <img src="/images/makecodearcade/explains/SpriteText/arcadetext15.png" alt="Text Sprite 글자 테두리 추가 적용" style={{ width: '30%', height: 'auto' }} />
          <p style={{ ...explainPaperTextStyle, fontSize: '14px' }}>
            textSprite 변수 안의 text 스프라이트의 테두리의 <b>두께</b>와 <b>색상</b>을 추가할 수 있습니다.
          </p>
          </div>
          <p style={{ marginBottom: '8px', fontSize: '14px', color: 'var(--Color-text-normal)' }}>
            사용 예시:
          </p>
          <div style={explainExamplePaperStyle}>
            <div style={explainExampleImageBoxStyle}>
              <img src="/images/makecodearcade/explains/SpriteText/arcadetext16.png" alt="Text Sprite 글자 테두리 추가 적용" style={{ width: '70%', height: 'auto' }} />
              <div style={{ width: 1, alignSelf: 'stretch', backgroundColor: 'var(--Color-line-normal)', margin: '0 8px' }} />
              <img src="/images/makecodearcade/explains/SpriteText/arcadetext17.png" alt="Text Sprite 글자 테두리 추가 시뮬레이터" style={{ width: '25%', height: 'auto' }} />
            </div>
          </div>
        </div>

      <div style={explainPaperStyle} id="text-sprite-박스-테두리-추가하기">
        <h3 style={explainPaperTitleStyle}>
          5. TextSprite 박스 테두리 추가하기
        </h3>
        <div style={{ display: 'flex', alignItems: 'flex-end', gap: '16px', marginBottom: '16px' }}>
          <img src="/images/makecodearcade/explains/SpriteText/arcadetext18.png" alt="Text Sprite 박스 테두리 추가 적용" style={{ width: '30%', height: 'auto' }} />
          <p style={{ ...explainPaperTextStyle, fontSize: '14px' }}>
            textSprite 변수 안의 text 스프라이트의 박스 테두리의 <b>두께</b>와 <b>색상</b>을 추가할 수 있습니다.
          </p>
        </div>
        <p style={{ marginBottom: '8px', fontSize: '14px', color: 'var(--Color-text-normal)' }}>
          사용 예시:
        </p>
        <div style={explainExamplePaperStyle}>
          <div style={explainExampleImageBoxStyle}>
            <img src="/images/makecodearcade/explains/SpriteText/arcadetext19.png" alt="Text Sprite 박스 테두리 추가 적용" style={{ width: '70%', height: 'auto' }} />
            <div style={{ width: 1, alignSelf: 'stretch', backgroundColor: 'var(--Color-line-normal)', margin: '0 8px' }} /> 
            <img src="/images/makecodearcade/explains/SpriteText/arcadetext20.png" alt="Text Sprite 박스 테두리 추가 시뮬레이터" style={{ width: '25%', height: 'auto' }} />
          </div>
        </div>
      </div>

      <div style={explainPaperStyle} id="text-sprite-텍스트-변경하기">
        <h3 style={explainPaperTitleStyle}>
          6. TextSprite 텍스트 변경하기
        </h3>
        <div style={{ display: 'flex', alignItems: 'flex-end', gap: '16px', marginBottom: '16px' }}>
          <img src="/images/makecodearcade/explains/SpriteText/arcadetext21.png" alt="Text Sprite 텍스트 변경하기" style={{ width: '30%', height: 'auto' }} />
          <p style={{ ...explainPaperTextStyle, fontSize: '14px' }}>
            textSprite 변수 안의 text 스프라이트의 텍스트를 변경할 수 있습니다.
          </p>
        </div>
        <p style={{ marginBottom: '8px', fontSize: '14px', color: 'var(--Color-text-normal)' }}>
          사용 예시:
        </p>
        <div style={explainExamplePaperStyle}>
          <div style={explainExampleImageBoxStyle}>
            <img src="/images/makecodearcade/explains/SpriteText/arcadetext22.png" alt="Text Sprite 텍스트 변경하기" style={{ width: '70%', height: 'auto' }} />
            <div style={{ width: 1, alignSelf: 'stretch', backgroundColor: 'var(--Color-line-normal)', margin: '0 8px' }} />
            <img src="/images/makecodearcade/explains/SpriteText/arcadetext23.gif" alt="Text Sprite 텍스트 변경하기" style={{ width: '25%', height: 'auto' }} />
          </div>
        </div>
      </div>

      <div style={explainPaperStyle} id="text-sprite-아이콘-추가하기">
        <h3 style={explainPaperTitleStyle}>
          7. TextSprite 아이콘 추가하기
        </h3>
        <div style={{ display: 'flex', alignItems: 'flex-end', gap: '16px', marginBottom: '16px' }}>
          <img src="/images/makecodearcade/explains/SpriteText/arcadetext23.png" alt="Text Sprite 아이콘 추가하기" style={{ width: '30%', height: 'auto' }} />
          <p style={{ ...explainPaperTextStyle, fontSize: '14px' }}>
            text 스프라이트 앞에 나만의 아이콘을 추가할 수 있습니다.
          </p>
        </div>
        <p style={{ marginBottom: '8px', fontSize: '14px', color: 'var(--Color-text-normal)' }}>
          사용 예시:
        </p>
        <div style={explainExamplePaperStyle}>
          <div style={explainExampleImageBoxStyle}>
            <img src="/images/makecodearcade/explains/SpriteText/arcadetext24.png" alt="Text Sprite 아이콘 블록 추가" style={{ width: '70%', height: 'auto' }} />
            <div style={{ width: 1, alignSelf: 'stretch', backgroundColor: 'var(--Color-line-normal)', margin: '0 8px' }} />
            <img src="/images/makecodearcade/explains/SpriteText/arcadetext25.png" alt="Text Sprite 아이콘 추가하기 시뮬레이터" style={{ width: '25%', height: 'auto' }} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TextSpriteExplain;